/** Centre par défaut — Vannes (siège / zone d’action Provéa). */
export const defaultMapCenter = {
  lat: 47.6582,
  lng: -2.7608,
};

/** Vue ville ; la carte programmes recadre automatiquement sur les marqueurs. */
export const defaultMapZoom = 11;
